/** @prettier */
import React, { useState } from "react";
import { User } from "../services/qbankApi";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { useAuthors, AuthorData } from "./authorsApi";
import { assert } from "../util/assert";

// Array.isArray doesn't work with readonly[] currently
// https://github.com/microsoft/TypeScript/issues/17002
const isArray = Array.isArray as (t: any) => t is readonly any[];

export type AssignAuthorModalState = {
    questionUuid: string | undefined;
    assignAuthor: (questionUuid: string, author: AuthorData) => void;
    me: User;
    productUuid: string;
};
type AssignAuthorModalProps = AssignAuthorModalState & {
    closeModal: () => void;
};
const AssignAuthorModal = ({
    questionUuid,
    closeModal,
    assignAuthor,
    me,
    productUuid,
}: AssignAuthorModalProps) => {
    const authorsList = useAuthors(productUuid);
    const meAuthor = authorsList.data?.find(
        ({ userUuid }) => userUuid === me.uuid,
    );
    const [selectedAuthor, setSelectedAuthor] = useState(meAuthor);
    const submit = async () => {
        assert(questionUuid, "questionUuid expected to exist");
        await assignAuthor(questionUuid, selectedAuthor!);
        closeModal();
    };
    return (
        <Modal show={true} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>Assign this question?</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <label id="assign-author-selector-label">Author:</label>
                {authorsList.error ? (
                    <div>Error loading authors</div>
                ) : !authorsList.data ? (
                    <div>
                        <FontAwesomeIcon icon="spinner" size="2x" spin />
                    </div>
                ) : (
                    <Select
                        aria-labelledby="assign-author-selector-label"
                        autoFocus
                        getOptionLabel={(a) => a.fullName}
                        getOptionValue={(a) => a.userUuid}
                        onChange={(author) => {
                            assert(!isArray(author), "Unexpected multi select");
                            setSelectedAuthor(author ?? undefined);
                        }}
                        options={authorsList.data}
                        value={selectedAuthor}
                    />
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="link" onClick={closeModal}>
                    Cancel
                </Button>
                <Button
                    bsStyle="primary"
                    disabled={!selectedAuthor}
                    onClick={submit}
                >
                    Assign
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignAuthorModal;
